<script>
    import {onMount} from 'svelte';
    // Lisätään blogi tähän. Päivämäärä nimessä auttaa järjestämisessä. Nimen voi keksiä ja url tulee sivun tiedostosta.
    // Tässä oikea .svelte -sivu ladataan sivun käyttöön
 //   import Blogi_2023_toiminnallinen_harjoittelu from         "../blog/2023-03_toiminnallinen_harjoittelu.svelte";
 //   import Blogi_2023_nn_kasillaseisonta from                 "../blog/2023-nn_kasillaseisonta.svelte";
    import Blogi_2025_hairiovaikutus from                       "../blog/2025-03-29_hairiovaikutus.svelte";
    import Blogi_2024_minimipanoksella_maksimi_tulos from       "../blog/2024-10-22_minimipanos.svelte";
    import Blogi_2023_vinkit_kestavaan_muutokseen from          "../blog/2023-03_vinkit_kestavaan_muutokseen.svelte";
    import Blogi_2023_pakarat_ja_kyykky_osa_3 from              "../blog/2023-02_pakaratreeni_osa_3.svelte";
    import Blogi_2023_pakarat_ja_kyykky_osa_2 from              "../blog/2023-02_pakaratreeni_osa_2.svelte";
    import Blogi_2023_pakarat_ja_kyykky_osa_1 from              "../blog/2023-02_pakaratreeni_osa_1.svelte";
    import Blogi_2022_09_11_otevoima from                       "../blog/2022-09-11_otevoima.svelte";
    import Blogi_2020_12_25_stressi from                        "../blog/2020-12-25_stressi.svelte";
    import Blogi_2020_04_28_TreenaaVauvankanssa from            "../blog/2020-04-28_TreenaaVauvankanssa.svelte";
    import Blogi_2020_01_16_Nopeusvoimaharjoittelu6Syyta from   "../blog/2020-01-16_Nopeusvoimaharjoittelu6Syyta.svelte";
    import Blogi_2019_06_06_NUTSKarhunkierros from              "../blog/2019-06-06_NUTSKarhunkierros.svelte";
    import Blogi_2019_03_04_HuonoKunto from                     "../blog/2019-03-04_huono_kunto.svelte";
    import Blogi_2018_08_28_MuscleUp from                       "../blog/2018-08-28_muscle_up.svelte";
    import Blogi_2018_08_06_juoksuvoimaa from                   "../blog/2018-08-06_juoksuvoimaa_lihaskuntoharjoittelusta.svelte";
    import Blogi_2018_08_18_Kyykkya from                        "../blog/2018-08-18_kyykkya_joka_paiva.svelte";
    import Blogi_2017_12_24_hauskaa from                        "../blog/2017-12-24_hauskat_treenit.svelte";
    import Blogi_2016_12_11_stressaako from                     "../blog/2016-12-11_stressaako.svelte";
    import Blogi_2016_10_16_nilkan_liikkuvuus2 from             "../blog/2016-10-16_nilkan_liikkuvuus_ja_huolto2.svelte";
    import Blogi_2016_10_02_nilkan_liikkuvuus1 from             "../blog/2016-10-02_nilkan_liikkuvuus_ja_huolto1.svelte";
    import Blogi_2016_01_06_treenimotivaatio from               "../blog/2016-01-06_treenimotivaatio.svelte";
    import Blogi_2015_10_20_voimaharjoittelun_pikaopas from     "../blog/2015-10-20_voimaharjoittelun_pikaopas.svelte";
    import Blogi_2015_10_04_aloittamisen_vaikeus from           "../blog/2015-10-04_aloittamisen_vaikeus.svelte";
    import Blogi_2015_02_01_ranteiden_huolto from               "../blog/2015-02-01_ranteiden_huolto.svelte";
    import Blogi_2015_01_06_Kunto_nousuun_kelkkaharjoittelulla from "../blog/2015-01-06_kunto_nousuun_kelkkaharjoittelulla.svelte";
    import Blogi_2014_11_17_selkavaivat_kuriin_treenaamalla from  "../blog/2014_11_17_selkavaivat_kuriin_treenaamalla.svelte";
    import Blogi_2014_09_20_vastuskuminauhat_6_vinkkia from     "../blog/2014-09-20_vastuskuminauhat_6_vinkkia.svelte";
    
    export let summary = false;
    export let blogUrl = "";
    let selected;

    // Copy paste ylhäältä tähän listaan ja uusin ylimmäksi aina. Muuta ei tarvi tehdä.
    // Tässä osoite linkitetään samaan muuttujaan
    const blogs = [
  //      { bUrl: "toiminnallinen_harjoittelu",            component: Blogi_2023_toiminnallinen_harjoittelu },
  //      { bUrl: "kohti_kasillaseisontaa",                component: Blogi_2023_nn_kasillaseisonta },
    //    { bUrl: "hairiovaikutus",                        component: Blogi_2025_hairiovaikutus },
        { bUrl: "minimipanoksella_maksimitulos",         component: Blogi_2024_minimipanoksella_maksimi_tulos },
        { bUrl: "vinkit_kestavaan_muutokseen",           component: Blogi_2023_vinkit_kestavaan_muutokseen },
        { bUrl: "voimaa_pakaratreenilla_osa_3",          component: Blogi_2023_pakarat_ja_kyykky_osa_3 },
        { bUrl: "voimaa_pakaratreenilla_osa_2",          component: Blogi_2023_pakarat_ja_kyykky_osa_2 },
        { bUrl: "voimaa_pakaratreenilla_osa_1",          component: Blogi_2023_pakarat_ja_kyykky_osa_1 },
        { bUrl: "2022-09-11_otevoima",                   component: Blogi_2022_09_11_otevoima },
        { bUrl: "stressitomasti-tuloksiin",              component: Blogi_2020_12_25_stressi },
        { bUrl: "treenaa-vauvan-kanssa",                 component: Blogi_2020_04_28_TreenaaVauvankanssa },
        { bUrl: "6-syyta-tehda-nopeusvoimaharjoittelua", component: Blogi_2020_01_16_Nopeusvoimaharjoittelu6Syyta },
        { bUrl: "nuts-karhunkierros-2019-83km",          component: Blogi_2019_06_06_NUTSKarhunkierros },
        { bUrl: "onko-sellaista-kun-liian-huono-kunto",  component: Blogi_2019_03_04_HuonoKunto },
        { bUrl: "muscle_up_renkaissa",                   component: Blogi_2018_08_28_MuscleUp },
        { bUrl: "kyykkya-joka-paiva",                    component: Blogi_2018_08_18_Kyykkya },
        { bUrl: "juoksuvoimaa_lihaskuntoharjoittelusta", component: Blogi_2018_08_06_juoksuvoimaa },
        { bUrl: "miten-tehda-treenaamisesta-hauskaa",    component: Blogi_2017_12_24_hauskaa },
        { bUrl: "stressaako",                            component: Blogi_2016_12_11_stressaako },
        { bUrl: "nilkan-liikkuvuus-ja-huolto-osa2",      component: Blogi_2016_10_16_nilkan_liikkuvuus2 },
        { bUrl: "nilkan-liikkuvuus-ja-huolto-osa1",      component: Blogi_2016_10_02_nilkan_liikkuvuus1 },
        { bUrl: "treenimotivaatio",                      component: Blogi_2016_01_06_treenimotivaatio },
        { bUrl: "voimaharjoittelun_pikaopas",            component: Blogi_2015_10_20_voimaharjoittelun_pikaopas },
        { bUrl: "aloittamisen_vaikeus",                  component: Blogi_2015_10_04_aloittamisen_vaikeus },
        { bUrl: "ranteiden_huolto",                      component: Blogi_2015_02_01_ranteiden_huolto },
        { bUrl: "kunto_nousuun_kelkkaharjoittelulla",    component: Blogi_2015_01_06_Kunto_nousuun_kelkkaharjoittelulla },
        { bUrl: "selkavaivat_kuriin_treenaamalla",       component: Blogi_2014_11_17_selkavaivat_kuriin_treenaamalla },
        { bUrl: "vastuskuminauhat_6_vinkkia",            component: Blogi_2014_09_20_vastuskuminauhat_6_vinkkia }
    ];

    blogs.forEach( b => {
        if (blogUrl == b.bUrl) {
            selected = b.component;
        }
    });

</script>

{#if summary && blogUrl === ""}
    <div class="row">
        {#each {length: 3} as _, i}
            <article class="blog col-xs-12 col-md-4">
                <svelte:component this={blogs[i].component} short="true"/>
            </article>
        {/each}
    </div>
{:else if blogUrl === ""}
    <div class="page">
        <div class="container">
            <h1>Blogi</h1>
            <div class="row">
                {#each blogs as blog, i}
                    <article class="blog col-xs-12 col-md-4">
                        <svelte:component this={blog.component} short="true"/>
                    </article>
                {/each}
            </div>
        </div>
    </div>
{:else if blogUrl != ""}
    <svelte:component this={selected}/>
{/if}
